// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"cf1f4f57","572":"1a5e332e"}[chunkId] + ".chunk.css";
};